import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Button, Grid, GridRow, GridColumn, Checkbox } from 'semantic-ui-react';
import { debounce } from 'lodash';

import { resetDirty } from '../../state/dirtyTracking/actions';
import { updateChargePermissions } from './state/chargeDefaults/actions';
import { isPreferenceDisabled } from 'Common/Security/SecurityHelpers';
import { PreferencesEnum as PrefEnum } from 'Common/Security/PreferencesEnum';
import { Filter, Main } from '../../containers';

import 'PageStyles/accountsetup/index.less';

import {
  getAccountSetup,
  getStudentAllergens,
  updateAllergenData,
  checkAll,
  postStudentAllergen,
  getStudentInfoAction,
  saveStudentFilters,
  getProhibitedItems,
  clearProhibitedItemsError,
  resetProhibitedItems,
  rowIndexUpdate,
  postStudentNumber,
  deleteStudent,
  getValidStatusFromApi,
  getTransactionHistory,
  clearMealHistory,
  clearChangeStudentNumber,
  setSelectedTab,
  clearStudentInfo,
  setIsNewStudent,
  setShowEditModal,
  getBillingAccountStudents,
  clearBillingAccountStudents,
} from './state/actions';
import {
  clearChangeBalanceError,
  resetChangeBalance,
} from './state/changebalance/actions';
import { withdrawStudent, clearWithdraw } from './state/withdraw/actions';
import { createToast, toastType } from '../../common/ToastHelper';
import { getLanguagesAction } from '../importstudents/state/actions';
import { getBasicSetup } from '../../components/basicsetup/state/actions';
import { StudentGrid } from './components/StudentGrid';
import { DirtyWrapper, StudentNotesModal } from '../../components/';
import { AllergenModal } from './components/AllergenModal';
import { StudentEditModal } from './components/StudentEditModal';
import { ProhibitedItemsModal } from './components/ProhibitedItemsModal';
import { StudentNumberModal } from './components/StudentNumberModal';
import { AccountSetupFunctions } from './AccountSetupFunctions';
import { SiteComponent } from '../../common/SiteComponent';
import { MealHistory } from './components/TransactionHistoryGrid';
import { YesNoDialog } from '../../components/dialogs/YesNoDialog';
import { WithdrawDialog } from './components/WithdrawDialog';
import { notWithdrawableStatuses } from './helpers/AccountSetupConstants';
import { ChangeBalanceModal } from './components/changebalance/ChangeBalanceModal';

class AccountSetupContainer extends AccountSetupFunctions {
  state = {
    siteChange: false,
    showAllergenModal: false,
    studentModalData: {},
    showProhibitedModal: false,
    showNotesModal: false,
    showChangeBalanceModal: false,
    showStudentNumberModal: false,
    showDeleteModal: false,
    showHistoryModal: false,
    showWithdrawDialog: false,
    siteId: '',
    addButtonClick: false,
  };

  timer = null;

  componentDidUpdate(prevProps, prevState) {
    this.prohibitedItemsNotifications(prevProps);
    this.withdrawNotifications(prevProps);
    this.changeBalanceNotifications(prevProps);

    if (this.props.changeNumber && !prevProps.changeNumber) {
      this.setState({ showStudentNumberModal: false });
      this.props.clearChangeStudentNumber();
      this.props.resetDirty();
    }
  }

  updateSiteChange = (value) => {
    this.props.getAccountSetup({
      PageNumber: 1,
      PageSize: 20,
      SiteId: value,
    });
    this.setState({
      siteChange: true,
      siteId: value,
    });
  };

  onEditClick = (studentModalData, girdIndexWithPage) => {
    const {
      rowIndexUpdate,
      getStudentInfoAction,
      setSelectedTab,
      getBasicSetup,
      getLanguagesAction,
      setIsNewStudent,
      setShowEditModal,
    } = this.props;
    setIsNewStudent(false);
    rowIndexUpdate(girdIndexWithPage + 1);
    setShowEditModal(true);
    getStudentInfoAction({
      PageNumber: girdIndexWithPage + 1,
      PageSize: 1,
      SiteId: this.state.siteId,
    });
    setSelectedTab(0);
    getBasicSetup('grade');
    getLanguagesAction();
  };

  showNewData = (obj) => {
    this.props.getStudentInfoAction(obj);
    this.props.rowIndexUpdate(obj.PageNumber);
  };

  newStudentModalClose = () => {
    this.props.setShowEditModal(false);
    if (this.state.addButtonClick) {
      this.setState({ addButtonClick: false });
    }
  };

  onAllergenClick = (studentModalData) => {
    this.setState(
      { showAllergenModal: true, studentModalData: studentModalData },
      () => {
        this.props.getStudentAllergens(studentModalData.Id);
      }
    );
  };

  closeAllergenModalYes = () => {
    this.setState({ showAllergenModal: false });
    this.props.resetDirty();
  };

  onProhibitedClick = (studentModalData) => {
    const { IdSeed } = studentModalData;

    this.setState(
      {
        showProhibitedModal: true,
        studentModalData,
      },
      () => this.props.getProhibitedItems(IdSeed)
    );
  };

  closeProhibitedModalYes = () => {
    this.setState({ showProhibitedModal: false });
    this.props.resetDirty();
  };

  closeNotesModalYes = () => {
    this.setState({ showNotesModal: false });
    this.props.resetDirty();
  };

  prohibitedItemsNotifications = (props) => {
    const error = this.props.prohibitedItemsError;
    const prevError = props.prohibitedItemsError;

    if (error && error !== prevError) {
      createToast(
        toastType.error,
        'Error',
        'An error occurred while saving. Please try again.',
        true
      );
      this.props.clearProhibitedItemsError();
    } else if (this.props.prohibitedItemsSaved && !props.prohibitedItemsSaved) {
      createToast(
        toastType.success,
        'Success',
        'Prohibited Items saved successfully.',
        true
      );

      this.setState({ showProhibitedModal: false });
      this.props.resetProhibitedItems();
      this.props.resetDirty();
    }
  };

  changeBalanceNotifications = (prevProps) => {
    const error = this.props.studentBalance.error;
    const prevError = prevProps.studentBalance.error;
    const successMessage = this.props.studentBalance.successMessage;
    const prevSuccessMessage = prevProps.studentBalance.successMessage;

    if (error && error !== prevError) {
      createToast(toastType.error, error.Title, error.Message, true);

      this.props.clearChangeBalanceError();
    } else if (successMessage && successMessage !== prevSuccessMessage) {
      createToast(toastType.success, 'Success', successMessage, true);

      this.closeChangeBalanceModal();
      this.props.resetChangeBalance();
    }
  };

  onWithdrawClick = (studentModalData) => {
    this.setState({ studentModalData, showWithdrawDialog: true });
  };

  onConfirmWithdraw = () => {
    this.props.withdrawStudent(this.state.studentModalData.IdSeed);
    this.setState({ studentModalData: {}, showWithdrawDialog: false });
  };

  onCancelWithdraw = () => {
    this.setState({ studentModalData: {}, showWithdrawDialog: false });
  };

  withdrawNotifications = (prevProps) => {
    const error = this.props.withdraw.error;
    const prevError = prevProps.withdraw.error;
    const successMessage = this.props.withdraw.successMessage;
    const prevSuccessMessage = prevProps.withdraw.successMessage;

    if (error && error !== prevError) {
      createToast(toastType.error, error.Title, error.Message, true);

      this.setState({ showWithdrawDialog: false });
      this.props.clearWithdraw();
    } else if (successMessage && successMessage !== prevSuccessMessage) {
      createToast(toastType.success, 'Success', successMessage, true);

      this.setState({ showWithdrawDialog: false });
      this.props.clearWithdraw();
    }
  };

  onHistoryClick = (studentModalData) => {
    this.setState({ showHistoryModal: true, studentModalData });
  };

  closeHistoryModal = () => {
    this.setState({ showHistoryModal: false });
    this.props.clearMealHistory();
  };

  onNotesClick = (studentModalData) => {
    this.setState({ showNotesModal: true, studentModalData });
  };

  onChangeBalanceClick = (studentModalData) => {
    this.setState({
      showChangeBalanceModal: true,
      studentModalData: studentModalData,
    });
  };

  closeChangeBalanceModal = () => {
    this.setState({ showChangeBalanceModal: false });
  };

  onChangeNumberClick = (studentModalData) => {
    this.setState({
      showStudentNumberModal: true,
      studentModalData: studentModalData,
    });
  };

  closeStudentNumberModal = () => {
    this.setState({ showStudentNumberModal: false });
  };

  saveNewStudentNumber = (number) => {
    const { postStudentNumber } = this.props;
    postStudentNumber(number);
  };

  onDeleteClick = (studentModalData) => {
    if(studentModalData.StatusCurrent === '9'){
      this.props.getBillingAccountStudents(studentModalData.Id)
    }
    this.setState({ showDeleteModal: true, studentModalData });
  };

  handleDialog(result) {
    if (result && this.billingAccountCheck(this.state.studentModalData)) {
        this.props.deleteStudent(this.state.studentModalData.IdSeed);
        this.setState({ studentModalData: {} });    
    }
    this.setState({ showDeleteModal: false });
    this.props.clearBillingAccountStudents()
  }

  billingAccountCheck = (student) =>{
    if(student.StatusCurrent === '9' && this.props.billingAccountStudents.length > 0){

      let studentsToBeRemoved = '';

      this.props.billingAccountStudents.forEach(student => {
        studentsToBeRemoved = studentsToBeRemoved.concat('\n', student.Id)
      });

      const message = `The following students are still using the billing account and must be removed in order to delete the account: ${studentsToBeRemoved}`
      createToast(toastType.info, 'Unable to Delete Billing Account', message)

      return false
    }
    return true
  }

  onAddStudentClick = () => {
    const {
      setSelectedTab,
      getBasicSetup,
      getLanguagesAction,
      getValidStatusFromApi,
      clearStudentInfo,
      setIsNewStudent,
    } = this.props;
    setIsNewStudent(true);
    clearStudentInfo();
    setSelectedTab(0);
    getBasicSetup('grade');
    getLanguagesAction();
    getValidStatusFromApi(null, 0, null, null);
    this.props.setShowEditModal(true);
    this.setState({ addButtonClick: true });
  };

  getMenuOptions = (isReadOnly) => {
    return [
      {
        icon: 'pencil',
        text: 'Edit',
        handler: (x, y) => this.onEditClick(x, y),
      },
      {
        icon: 'history',
        text: 'Meal History',
        handler: (x) => this.onHistoryClick(x),
      },
      {
        icon: 'food',
        text: 'Assign Allergen(s)',
        handler: (x) => this.onAllergenClick(x),
      },
      {
        icon: 'sticky note',
        text: 'Notes',
        handler: (x) => this.onNotesClick(x),
      },
      {
        icon: 'dollar',
        text: 'Change Balance',
        handler: (x) => this.onChangeBalanceClick(x),
        disabledWhen: (x) => {
          return isPreferenceDisabled(
            PrefEnum.ChangeStudentBalance,
            this.props.security.preferences
          );
        },
      },
      {
        icon: 'subscript',
        text: 'Change Student #',
        handler: (x) => this.onChangeNumberClick(x),
        disabledWhen: (x) =>
          x.StatusCurrent === '9' ||
          isPreferenceDisabled(
            PrefEnum.ChangeStudentNumber,
            this.props.security.preferences
          ),
      },
      {
        icon: 'dont',
        text: 'Prohibited',
        handler: (x) => this.onProhibitedClick(x),
      },

      {
        icon: 'undo',
        text: 'Withdraw',
        handler: (x) => this.onWithdrawClick(x),
        disabledWhen: (x) => {
          return (
            notWithdrawableStatuses.includes(x.StatusCurrent) ||
            isPreferenceDisabled(
              PrefEnum.WithdrawStudent,
              this.props.security.preferences
            )
          );
        },
      },

      {
        icon: 'trash',
        text: 'Delete',
        className: 'danger',
        handler: (x) => this.onDeleteClick(x),
        disabledWhen: (x) => {
          return (
            (x.HouseholdId !== '' && x.HouseholdId !== null) ||
            isPreferenceDisabled(
              PrefEnum.DeleteStudent,
              this.props.security.preferences
            )
          );
        },
      },
    ];
  };

  fetchTransactionHistoryData = (
    pageNumber,
    pageSize,
    sortOptions,
    filterOptions
  ) => {
    const { getTransactionHistory } = this.props;
    const { studentModalData } = this.state;
    getTransactionHistory(
      pageNumber,
      pageSize,
      sortOptions,
      filterOptions,
      studentModalData.IdSeed
    );
  };

  fetchTransactionHistoryDataDebounced = (
    pageNumber,
    pageSize,
    sortOptions,
    filterOptions,
    idSeed
  ) => {
    const debouncedFetch = debounce(this.fetchTransactionHistoryData, 50);

    debouncedFetch(pageNumber, pageSize, sortOptions, filterOptions, idSeed);
  };

  render() {
    const {
      gridLoading,
      allergenData,
      initialAllergenData,
      studentIdData,
      studentData,
      studentInfo,
      isReadOnly,
      transactionData,
      siteDropdownLoading,
      transactionHistoryPages,
    } = this.props;

    const {
      siteChange,
      studentModalData,
      showAllergenModal,
      showStudentNumberModal,
      showChangeBalanceModal,
      showProhibitedModal,
      showNotesModal,
      showDeleteModal,
      showHistoryModal,
      addButtonClick,
      siteId,
    } = this.state;
    const data = (studentData && studentData.Result) || [];
    const TotalPages = studentData && studentData.TotalPages;

    return (
      <Fragment>
        <Filter title={'Account Setup'}>
          <Grid>
            <GridRow>
              <GridColumn width="5">
                <Checkbox
                  label="Show Withdrawn"
                  toggle
                  onChange={this.showWithdrawnChange}
                  disabled={gridLoading || !siteChange}
                />
              </GridColumn>

              <GridColumn width="6">
                <SiteComponent
                  onChange={this.updateSiteChange}
                  loading={gridLoading}
                />
              </GridColumn>

              <GridColumn width="5" floated="right" textAlign="right">
                <Button
                  content="Add Student"
                  onClick={this.onAddStudentClick}
                  disabled={isReadOnly || siteDropdownLoading}
                  loading={siteDropdownLoading}
                />
              </GridColumn>
            </GridRow>
          </Grid>
        </Filter>
        <Main shouldNotUsePageWidth>
          <StudentGrid
            siteChange={siteChange}
            data={data}
            TotalPages={TotalPages}
            menuOptions={this.getMenuOptions(isReadOnly)}
            onRef={(ref) => (this.studentGrid = ref)}
          />
        </Main>
        <DirtyWrapper
          closeModalYesCallback={this.closeAllergenModalYes}
          isReadOnly={isPreferenceDisabled(
            PrefEnum.AssignAllergens,
            this.props.security.preferences
          )}
        >
          {(showDirtyConfirm) =>
            showAllergenModal &&
            allergenData && (
              <AllergenModal
                showAllergenModal={showAllergenModal}
                onClose={showDirtyConfirm}
                allergenData={allergenData}
                initialAllergenData={initialAllergenData}
                studentModalData={studentModalData}
                saveAllergen={(data) => {
                  this.setState({
                    showAllergenModal: false,
                    studentModalData: {},
                  });
                  this.props.postStudentAllergen(data);
                }}
                checkAll={(a, b) => this.props.checkAll(a, b)}
                updateAllergenData={(data) =>
                  this.props.updateAllergenData(data)
                }
              />
            )
          }
        </DirtyWrapper>
        <DirtyWrapper
          closeModalYesCallback={this.closeEditModalYes}
          showNewDataYesCallback={this.showNewData}
          isReadOnly={isReadOnly}
        >
          {(
            showDirtyConfirm,
            showDirtyLinkConfirm,
            showNewDataDirtyConfirm
          ) => (
            <StudentEditModal
              onClose={showDirtyConfirm}
              studentSeedData={studentIdData}
              showDirtyLinkConfirm={showDirtyLinkConfirm}
              isReadOnly={isReadOnly}
              showNewDataDirtyConfirm={showNewDataDirtyConfirm}
              newStudent={addButtonClick}
              addStudentModalClose={this.newStudentModalClose}
              studentInfo={studentInfo}
              siteId={siteId}
            />
          )}
        </DirtyWrapper>
        <DirtyWrapper closeModalYesCallback={this.closeProhibitedModalYes}>
          {(showDirtyConfirm) => {
            const props = {
              modalProps: {
                open: showProhibitedModal,
                onClose: showDirtyConfirm,
              },
              student: studentModalData,
            };

            return <ProhibitedItemsModal {...props} />;
          }}
        </DirtyWrapper>

        {showNotesModal && (
          <StudentNotesModal
            open={showNotesModal}
            onClose={this.closeNotesModalYes}
            isReadOnly={isReadOnly}
            studentData={studentModalData}
          />
        )}

        {showChangeBalanceModal && (
          <ChangeBalanceModal
            modalProps={{
              open: showChangeBalanceModal,
              onClose: this.closeChangeBalanceModal,
            }}
            student={studentModalData}
          />
        )}

        {showStudentNumberModal && (
          <StudentNumberModal
            showStudentNumberModal={showStudentNumberModal}
            onClose={this.closeStudentNumberModal}
            studentModalData={studentModalData}
            saveStudentNumber={this.saveNewStudentNumber}
            loading={this.props.changeNumberLoading}
          />
        )}

        {transactionData && (
          <MealHistory
            studentModalData={studentModalData}
            showHistoryModal={showHistoryModal}
            getData={this.fetchTransactionHistoryDataDebounced}
            onClose={this.closeHistoryModal}
            pages={transactionHistoryPages}
          />
        )}
        {showDeleteModal && (
          <YesNoDialog
            showDialog={showDeleteModal}
            title={`Delete - ${studentModalData.FirstName} ${studentModalData.LastName} `}
            question={`Are you sure you want to DELETE Stu#- ${studentModalData.Id} ?`}
            yesCallback={() => {
              this.handleDialog(true);
            }}
            noCallback={() => {
              this.handleDialog(false);
            }}
          />
        )}
        <WithdrawDialog
          student={this.state.studentModalData}
          shown={this.state.showWithdrawDialog}
          onConfirm={this.onConfirmWithdraw}
          onCancel={this.onCancelWithdraw}
          loading={this.props.withdraw.loading}
        />
      </Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    studentData: state.AccountSetupState.studentData,
    studentInfo: state.AccountSetupState.studentInfo,
    gridLoading: state.AccountSetupState.gridLoading,
    allergenData: state.AccountSetupState.allergenData,
    initialAllergenData: state.AccountSetupState.initialAllergenData,
    studentIdData: state.AccountSetupState.studentSeedData,
    studentFilter: state.AccountSetupState.studentFilter,
    prohibitedItemsError: state.AccountSetupState.prohibitedItemsError,
    prohibitedItemsSaved: state.AccountSetupState.prohibitedItemsSaved,
    changeNumber: state.AccountSetupState.changeNumber,
    transactionData: state.AccountSetupState.transactionHistory,
    changeNumberLoading: state.AccountSetupState.changeNumberLoading,
    withdraw: state.AccountSetupState.withdraw,
    studentBalance: state.AccountSetupState.studentBalance,
    isNewStudent: state.AccountSetupState.isNewStudent,
    showEditModal: state.AccountSetupState.showEditModal,
    siteDropdownLoading: state.CommonState.sites.loading,
    transactionHistoryPages: state.AccountSetupState.transactionHistoryPages,
    security: state.SecurityState,
    billingAccountStudents: state.AccountSetupState.billingAccountStudents
  };
};

export const AccountSetup = withRouter(
  connect(mapStateToProps, {
    getAccountSetup,
    getStudentAllergens,
    checkAll,
    updateAllergenData,
    postStudentAllergen,
    getStudentInfoAction,
    getLanguagesAction,
    getBasicSetup,
    saveStudentFilters,
    resetDirty,
    getProhibitedItems,
    clearProhibitedItemsError,
    resetProhibitedItems,
    rowIndexUpdate,
    postStudentNumber,
    deleteStudent,
    getValidStatusFromApi,
    getTransactionHistory,
    clearMealHistory,
    clearChangeStudentNumber,
    withdrawStudent,
    clearWithdraw,
    setSelectedTab,
    clearStudentInfo,
    resetChangeBalance,
    clearChangeBalanceError,
    setIsNewStudent,
    setShowEditModal,
    updateChargePermissions,
    getBillingAccountStudents,
    clearBillingAccountStudents,
  })(AccountSetupContainer)
);



// WEBPACK FOOTER //
// ./src/pages/accountsetup/AccountSetup.js